<head>
    <style>
        .my-pagination /deep/ .ngx-pagination .current {
            font-family: "Graphik SemiBold";
            font-weight: normal;
            font-style: normal;
            font-display: swap;
            color: #265d6e;
            background: transparent;
        }
    </style>
</head>
<div class="container-fluid">
    <div id="success-alert" class="alert alert-success alert-dismissible fade show" role="alert">
        <strong id="videoTitle"></strong> <span id="message"> </span>
        <button (click)="closeSuccessAlert()" type="button" class="close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div id="error-alert" class="alert alert-danger alert-dismissible fade show" role="alert">
        <span id="error-message"></span>
        <button (click)="closeErrorAlert()" type="button" class="close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <nav class="navbar navbar-light sub-nav">
        <a class="navbar-brand" [routerLink]="['/home']">
            <h5 class="Ws-subtitle">{{constants.WINDOW_APPROVED_TXT}}</h5>
        </a>
        <span class="navbar-text justify-content-end">
            <input id="search" class="search" type="text" placeholder="search" (ngModelChange)="Search()"
                [(ngModel)]="videoTitle" (ngModelChange)="Search()">
        </span>
    </nav>
    <div class="row">
        <div style="width: 100%;padding: 10px;" class="col-6">
            <!-- <div>
                <img class="video-title" style="width: 50%;" *ngIf="isLoading"
                    src="{{constants.VIDEO_TITLE_SKELTON_IMG}}" alt="">
                <input *ngIf="!isLoading" [disabled]="disableEdit" class="video-title" type="text"
                    value="{{currentVideoTitle}}" placeholder="{{currentVideoTitle}}"> -->
            <!-- <span>
                    <button id="edit-details" (click)="onClickEdit($event)"
                        class="edit-details">{{constants.EDIT_TXT}}</button>
                     <button id="cancel" (click)="onClickCancel($event)"
                        class="cancel">{{constants.CANCEL_TXT}}</button> 
                     <button id="done" (click)="onClickDone($event)" class="done">{{constants.DONE_TXT}}</button> 
                </span> -->
            <!-- </div> -->


            <img class="video-player" *ngIf="isLoading" src="{{constants.PLAYER_SKELTON_IMG}}" alt="">
            <img class="video-player" *ngIf="videos?.length === 0" src="{{constants.PLAYER_SKELTON_IMG}}" alt="">
            <video controls class="video-player" src="{{currentUrl}}"
                *ngIf="!isLoading && videos?.length !== 0"></video>


            <div class="row" id="title-container">
                <div class="col" style="width: 100%;">
                    <img class="video-title " *ngIf="isLoading" src="{{constants.VIDEO_TITLE_SKELTON_IMG}}" alt="">
                    <p id="currentVideoTitle" class="video-title col-8">{{currentVideoTitle}}</p>

                </div>
                <div class="col-3">
                    <button id="edit-details" (click)="onClickEdit($event)"
                        class="edit-details ">{{constants.EDIT_TXT}}</button>
                </div>
            </div>
            <div class="row edit-form-container" id=edit-form>
                <form action="" [formGroup]="titleEdit">
                    <input class="input-title-edit col-3" type="text" placeholder="NickName" formControlName="nickName">
                    <input class="input-title-edit col-4" type="text" placeholder="Location" formControlName="location">
                    <input class="input-title-edit col-4" type="text" placeholder="Country" formControlName="country">
                    <div class="edit-tag-container" formGroupName="tags">
                        <div>
                            <input class="edit-tag" type="checkbox" name="" id="animals" formControlName="Animals">
                            <label for="animals">animals</label>
                        </div>
                        <div>
                            <input class="edit-tag" type="checkbox" name="" id="rain" formControlName="Rain">
                            <label for="rain">rain</label>
                        </div>
                        <div>
                            <input class="edit-tag" type="checkbox" name="" id="snow" formControlName="Snow">
                            <label for="snow">snow</label>
                        </div>
                        <div>
                            <input class="edit-tag" type="checkbox" name="" id="city" formControlName="City">
                            <label for="city">city</label>
                        </div>
                        <div>
                            <input class="edit-tag" type="checkbox" name="" id="nature" formControlName="Nature">
                            <label for="nature">nature</label>
                        </div>
                        <div>
                            <input class="edit-tag" type="checkbox" name="" id="night" formControlName="Night">
                            <label for="night">night</label>
                        </div>
                        <div>
                            <input class="edit-tag" type="checkbox" name="" id="day" formControlName="Day">
                            <label for="day">day</label>
                        </div>
                        <div>
                            <input class="edit-tag" type="checkbox" name="" id="interior" formControlName="Interior">
                            <label for="interior">interior</label>
                        </div>
                        <div>
                            <input class="edit-tag" type="checkbox" name="" id="water" formControlName="Water">
                            <label for="water">water</label>
                        </div>
                    </div>
                    <button id="cancel" (click)="onClickCancel($event)" class="cancel">{{constants.CANCEL_TXT}}</button>
                    <button [disabled]="isEditProcessing" id="done" (click)="onClickDone($event)" class="done">
                        <span *ngIf="isEditProcessing" class="spinner-border spinner-border-sm name-update-spinner"
                            role="status" aria-hidden="true"></span>{{constants.DONE_TXT}}</button>
                </form>
            </div>
            <div class="tag-container" id="tag-container">
                <div disabled class="checkbox-button" [ngClass]="{'checkbox-button-active': animalsActive}">
                    <input class="tag-checkbox" id="animals" type="checkbox">
                    <img class="checkbox-img" [src]="constants.CHECKBOX_GREEN_IMG" alt="">
                    <img class="checkbox-close" [src]="constants.CLOSE_GREEN_IMG" alt="">
                    <label for="animals" id="animals-label" class="label-text">{{constants.ANIMALS_TXT}}</label>
                </div>
                <div class="checkbox-button" [ngClass]="{'checkbox-button-active': rainActive}">
                    <input class="tag-checkbox" id="rain" type="checkbox">
                    <img class="checkbox-img" [src]="constants.CHECKBOX_GREEN_IMG" alt="">
                    <img class="checkbox-close" [src]="constants.CLOSE_GREEN_IMG" alt="">
                    <label for="rain" id="rain-label" class="label-text">{{constants.RAIN_TXT}}</label>
                </div>
                <div class="checkbox-button" [ngClass]="{'checkbox-button-active': snowActive}">
                    <input class="tag-checkbox" id="snow" type="checkbox">
                    <img class="checkbox-img" [src]="constants.CHECKBOX_GREEN_IMG" alt="">
                    <img class="checkbox-close" [src]="constants.CLOSE_GREEN_IMG" alt="">
                    <label for="snow" id="snow-label" class="label-text">{{constants.SNOW_TXT}}</label>
                </div>
                <div class="checkbox-button" [ngClass]="{'checkbox-button-active': cityActive}">
                    <input class="tag-checkbox" id="city" type="checkbox">
                    <img class="checkbox-img" [src]="constants.CHECKBOX_GREEN_IMG" alt="">
                    <img class="checkbox-close" [src]="constants.CLOSE_GREEN_IMG" alt="">
                    <label for="city" id="city-label" class="label-text">{{constants.CITY_TXT}}</label>
                </div>
                <div class="checkbox-button" [ngClass]="{'checkbox-button-active': natureActive}">
                    <input class="tag-checkbox" id="nature" type="checkbox">
                    <img class="checkbox-img" [src]="constants.CHECKBOX_GREEN_IMG" alt="">
                    <img class="checkbox-close" [src]="constants.CLOSE_GREEN_IMG" alt="">
                    <label for="nature" id="nature-label" class="label-text">{{constants.NATURE_TXT}}</label>
                </div>
                <div class="checkbox-button" [ngClass]="{'checkbox-button-active': nightActive}">
                    <input class="tag-checkbox" id="night" type="checkbox">
                    <img class="checkbox-img" [src]="constants.CHECKBOX_GREEN_IMG" alt="">
                    <img class="checkbox-close" [src]="constants.CLOSE_GREEN_IMG" alt="">
                    <label for="night" id="night-label" class="label-text">{{constants.NIGHT_TXT}}</label>
                </div>
                <div class="checkbox-button" [ngClass]="{'checkbox-button-active': dayActive}">
                    <input class="tag-checkbox" id="day" type="checkbox">
                    <img class="checkbox-img" [src]="constants.CHECKBOX_GREEN_IMG" alt="">
                    <img class="checkbox-close" [src]="constants.CLOSE_GREEN_IMG" alt="">
                    <label for="day" id="day-label" class="label-text">{{constants.DAY_TXT}}</label>
                </div>
                <div class="checkbox-button" [ngClass]="{'checkbox-button-active': interiorActive}">
                    <img class="checkbox-img" [src]="constants.CHECKBOX_GREEN_IMG" alt="">
                    <img class="checkbox-close" [src]="constants.CLOSE_GREEN_IMG" alt="">
                    <label for="interior" id="interior-label" class="label-text">{{constants.INTERIORS_TXT}}</label>
                </div>
                <div class="checkbox-button" [ngClass]="{'checkbox-button-active': waterActive}">
                    <img class="checkbox-img" [src]="constants.CHECKBOX_GREEN_IMG" alt="">
                    <img class="checkbox-close" [src]="constants.CLOSE_GREEN_IMG" alt="">
                    <label for="water" id="water-label" class="label-text">{{constants.WATER_TXT}}</label>
                </div>
            </div>
            <!-- <img class="video-player" *ngIf="isLoading" src="{{constants.PLAYER_SKELTON_IMG}}" alt="">
            <img class="video-player" *ngIf="videos?.length === 0" src="{{constants.PLAYER_SKELTON_IMG}}" alt="">
            <video controls class="video-player" src="{{currentUrl}}" *ngIf="!isLoading && videos?.length !== 0"></video> -->
            <div class="button-container">
                <button [disabled]="isProcessing" (click)="onClickUploadToVimeo($event)" class="button-accept">
                    <span *ngIf="isProcessing" class="spinner-border spinner-border-sm" role="status"
                        aria-hidden="true"></span>
                    {{constants.UPLOADTOVIMEO_TXT }}</button>
            </div>
        </div>
        <div class="col-6  table-responsive">
            <table class="table">
                <tbody>
                    <tr *ngIf="isLoading">
                        <div *ngFor="let item of skeltonArray">
                            <td>
                                <img style="width: 81%;" [src]="item" alt="">
                            </td>
                        </div>
                    </tr>
                    <tr *ngIf="!isLoading">
                        <div *ngIf="videos?.length === 0">
                            <td>
                                <p class="error">List is empty...
                                </p>
                            </td>
                        </div>
                    </tr>
                    <tr id="{{video.videoName}}"
                        *ngFor="let video of videos |filter:videoTitle | paginate: { itemsPerPage: 5, currentPage: p }">
                        <td *ngIf="!isLoading">
                            <div class="row">
                                <div class="col-8 table-card" (click)="onclickRow(video)">
                                    <div class="icon-container">
                                        <video class="pending-video-icon" src="{{video.url}}">
                                        </video>
                                    </div>

                                    <div class="pending-video-title" id="pending-video-title">
                                        <h6 id="{{video.videoName}}-title">{{video.videoTitle}}</h6>
                                        <span style="font-size: 14px;">{{video.uploadedOn}}</span>
                                        <span class="approved-video-creator">{{video.creatorName}}</span>
                                    </div>
                                </div>
                                <!-- <span><button class="decline">Decline</button></span>
                                <span><button (click) = onClickUploadToVimeo($event) class="upload">Upload</button></span> -->
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
            <pagination-controls class="my-pagination" (pageChange)="p = $event"></pagination-controls>
        </div>
    </div>
</div>